import PropTypes from "prop-types";
import {Provider as ReduxProvider} from "react-redux";
import store from "../../redux/store.js";
import {ReactKeycloakProvider} from '@react-keycloak/web'
import keycloak from "../../keycloak.js";
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {ErrorBoundary} from "./ErrorBoundry.jsx";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/custom.scss';
import {ToastContainer} from "react-toastify";


export const Providers = (props) => {


    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{
                onLoad: 'login-required',
                checkLoginIframe: window.NODE_ENV === 'production'
            }}>
            <ReduxProvider store={store}>
                <QueryClientProvider client={new QueryClient({
                    defaultOptions: {
                        queries: {
                            refetchOnWindowFocus: false,
                            retry: false,
                        },
                    },
                })}>
                    <ErrorBoundary>
                        {props.children}
                        <ToastContainer
                            position="bottom-left"
                            draggable
                            theme={'dark'}
                            newestOnTop
                        />
                    </ErrorBoundary>
                    <ReactQueryDevtools initialIsOpen={false}/>
                </QueryClientProvider>
            </ReduxProvider>
        </ReactKeycloakProvider>
    )
}

Providers.propTypes = {
    children: PropTypes.node.isRequired,
};